import { createFileRoute } from "@tanstack/react-router";
import { KostenPage, kostenHead } from "../components/KostenPage";
import { kostenGuides } from "../lib/kosten-guides";

export const Route = createFileRoute("/renovatie-kosten")({
  head: () => kostenHead(kostenGuides.renovatie),
  component: () => <KostenPage guide={kostenGuides.renovatie} />,
});
